import React, { Component } from 'react';
import { InfoWindow, Map, Marker } from 'google-maps-react';
import { MyContext } from '../context';

export default class MapContainer extends Component {

  constructor() {
    super();
    this.state = {
      center: { lat: 37.4740497, lng: -96.9519661 },
      zoom: 4
    }
  }

  render() {
    const style = { // MUST specify dimensions of the Google map or it will not work. Also works best when style is specified inside the render function and created as an object
      height: '70vh' // 75vh similarly will take up roughly 75% of the height of the screen. px also works.
    }
    // ==================
    // ADD MARKERS TO MAP
    // ==================
    return (
      <MyContext.Consumer>
        {state => {
          return (
            <div style={style} >
              <Map
                item
                xs={12}
                google={this.props.google}
                zoom={this.state.zoom}
                center={this.state.center}
              >
                {
                  Object.keys(state.activeDriverList).map(key => {
                    return <Marker key={key}
                      onClick={e => {
                        this.onMarkerClick({
                          lat: state.activeDriverList[key].coordinate[0],
                          lng: state.activeDriverList[key].coordinate[1]
                        })
                      }}
                      title={state.activeDriverList[key].fullName}
                      position={{
                        lat: state.activeDriverList[key].coordinate[0],
                        lng: state.activeDriverList[key].coordinate[1]
                      }}
                    // name={'Changing Colors Garage'}
                    ></Marker>
                  })
                }
              </Map>
            </div>
          )
        }}
      </MyContext.Consumer>
    )
  }
  onMarkerClick(location) {
    this.setState({
      center: location,
      zoom: 16
    })
  }
}


// WEBPACK FOOTER //
// ./src/include/MapContainer.js